import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'wiz-page-list',
template: templateSource || '',
    styles: [``],
})
export class PageListComponent implements OnInit {

    public changeKey = '';
    public keywords: string = '';
    public searchMode = "name";

    public user_list: any;
    public like_list = [];
    public total = 0;

    private page = {
        current: 1,
        start: 1,
        end: 1
    };

    public loading = false;
    public init = false;

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router    )         private router: Router    ) { }

    public async ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.keywords = params['keywords'] || '';
            this.searchMode = params['mode'] || '';
        });
        if (!this.keywords) {
            await this.service.alert.show({
                title: "",
                action: "확인",
                actionBtn: "error",
                message: "검색어가 없습니다.",
                cancel: false,
            });
            this.router.navigate(['/main']);
            return;
        }
        this.init = true;
        this.loading = true;
        await this.service.render()
        await this.search();

        document.addEventListener('click', () => {
            this.user_list.forEach(u => (u.showTagsDropdown = false));
            this.service.render();
        });
    }

    public async search() {

        if (!this.keywords || this.keywords.trim() === '') {
            await this.service.alert.show({
                title: "",
                action: "확인",
                actionBtn: "error",
                message: "검색어를 입력해주세요.",
                cancel: false,
            });
            this.loading = false;
            return;
        }
        if (this.keywords !== this.changeKey) this.page.current = 1;
        this.user_list = [];
        this.init = true;
        this.loading = true;
        this.total = 0;
        await this.service.render();

        const url = new URL(window.location);
        url.searchParams.set("keywords", this.keywords);
        url.searchParams.set("mode", this.searchMode);
        window.history.pushState({}, "", url);
        this.changeKey = this.keywords;

        const { code, data } = await wiz.call('search', { page: this.page.current, keyword: this.keywords, mode: this.searchMode });
        if (code !== 200) {
            this.loading = false;
            await this.service.render();
        }

        this.user_list = data.user_list;
        this.total = data.total.toLocaleString();
        this.page.end = data.lastpage;

        this.loading = false;
        this.init = false;
        await this.service.render();
    }

    public async detail(u) {
        this.router.navigate(
            ['/detail', u.auth_id]
        );
    }

    public async toggleTagDropdown(user: any, event: MouseEvent) {
        event.stopPropagation();
        const check = user.showTagsDropdown === true;
        this.user_list.forEach(u => (u.showTagsDropdown = false));
        if (!check) user.showTagsDropdown = true;
        await this.service.render();
    }

    public formatOrgs(orgs: string[] | null): string {
        if (!orgs || orgs.length === 0) return '-';

        if (orgs.length <= 3) {
            return orgs.join(', ');
        }

        return `${orgs.slice(0, 3).join(', ')}, ...`;
    }

    ////----사용x----////

    //임시
    orgs = [
        '한국과학기술정보연구원',
        '한국항공우주연구원',
        '한국과학기술정보연구원',
        '한국과학기술정보연구원',
        '한국과학기술정보연구원',
        '한국과학기술정보연구원',
        '한국한의학연구원'
    ];

    public filter = {
        org: [],
        paper_min: 0,
        paper_max: 0,
        patent_min: 0,
        patent_max: 0,
        report_min: 0,
        report_max: 0
    }

    public sections = [
        { key: 'paper', label: '논문' },
        { key: 'patent', label: '특허' },
        { key: 'report', label: '보고서' },
    ];

    public num = [
        { min: 0, max: 5, label: '5건 이하' },
        { min: 5, max: 10, label: '5건~10건' },
        { min: 11, max: 15, label: '11건~15건' },
        { min: 16, max: 20, label: '16건~20건' },
        { min: 20, max: 99999, label: '20건 이상' },
        { min: 0, max: 50, label: '직접 입력' }
    ] as const;

    public selectIdx = {
        paper: null,
        patent: null,
        report: null,
    }

    //필터
    public selectOrg(i) {
        const org = this.orgs[i];
        if (!this.filter.org.includes(org)) {
            this.filter.org.push(org);
        } else {
            this.filter.org = this.filter.org.filter(o => o !== org);
        }
    }

    public changeOpt(key, opt) {
        if (!opt) {
            this.filter[`${key}_min`] = 0;
            this.filter[`${key}_max`] = 0;
        } else {
            const isCustom = opt.min === 0 && opt.max === 50;
            if (!isCustom) {
                this.filter[`${key}_min`] = opt.min;
                this.filter[`${key}_max`] = opt.max;
            }
        }
    }

    public async reset(opt) {
        if (opt == 'all') {
            this.filter = {
                org: [],
                paper_min: 0,
                paper_max: 0,
                patent_min: 0,
                patent_max: 0,
                report_min: 0,
                report_max: 0
            }
            this.selectIdx = {
                paper: null,
                patent: null,
                report: null,
            }
        } else if (opt == 'org') {
            this.filter.org = [];
        } else {
            this.selectIdx[opt] = null;
            this.changeOpt(opt, null)
        }
        await this.service.render();
    }


    // 추천
    public async like(id, event: MouseEvent) {
        event.stopPropagation();
        let status;
        if (this.like_list.includes(id)) {
            this.like_list = this.like_list.filter(x => x !== id);
            status = false;
        } else {
            this.like_list.push(id);
            status = true;
        }

        sessionStorage.setItem("like", JSON.stringify(this.like_list));
        await this.service.render();
        const { code, data } = await wiz.call("like", { 'id': id, 'status': status });
        if (code !== 200) {
            await this.service.alert.show({
                title: "",
                action: "확인",
                actionBtn: "error",
                message: "좋아요를 누를 수 없습니다.",
                cancel: false,
            });
            return;
        }
    }

    public isLiked(id) {
        try {
            const likes = JSON.parse(sessionStorage.getItem("like") || "[]");
            return likes.includes(id);
        } catch {
            return false;
        }
    }

}

export default PageListComponent;